import React, { useState, useEffect } from "react";
import { FaBell, FaTimes } from "react-icons/fa";
// import { IoMdNotificationsOutline } from "react-icons/io";
import { getFetcher, postFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import Spinner from "../spinner/Spinner";
// import ic3 from "../../assets/images/novaic3.png";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useLanguage } from "../../context/LanguageContext";


interface Notification {
  id: string;
  userId: string;
  title: string;
  message: string;
  isRead: boolean;
  type: string;
  status: boolean;
  createdAt: string;
  updatedAt: string;
}

const NotificationsDropdown: React.FC = () => {
  const {t} = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);


  const fetchNotifications = async () => {
    try {
      // setIsLoading(true);
      const response = await getFetcher(
        endpoints.notifications.getNotifications
      );
      if (response.result) {
        setNotifications(response.notifications);
        const unreadNotifications = response?.notifications?.filter(
          (notification: Notification) => !notification.isRead
        ).length;
        setUnreadCount(unreadNotifications);
        setIsLoading(false);
      } else {
        console.log("Error fetching notifications:", response);
        setNotifications([]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setIsLoading(false);
    }
  };

  const toggleDropdown = async () => {
    if (isOpen) {
      try {
        await postFetcher(endpoints.notifications.markAsRead, { arg: {} });
        setNotifications((prevNotifications) =>
          prevNotifications.map((notification: any) => ({
            ...notification,
            isRead: true,
          }))
        );
        setUnreadCount(0);
      } catch (error) {
        console.error("Error marking notifications as read:", error);
      }
    }
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen) {
      fetchNotifications();
    }
  }, [isOpen]);

  return (
    <div className=" absolute -mt-0 md:-mt-[19px] ml-0 md:ml-[13px]">
      <div className="relative cursor-pointer" onClick={toggleDropdown}>
        <IoMdNotificationsOutline className=" text-yellow-color hover:scale-110 transition-transform duration-300 transform text-[25px]"/>
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-primary-color"></span>
        )}
      </div>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 min-h-screen"
            onClick={toggleDropdown}
          ></div>
          <div className="absolute -right-5 md:right-0 mt-2 w-[220px] sm:w-[250px] bg-[#141C3A] text-white rounded-xl shadow-lg z-50 md:w-96 sm:right-0 sm:top-0 sm:mt-0 min-h-[300px]">
            <div className=" relative flex justify-center items-center p-4 border-b border-gray-200">
              <span className="font-bold text-lg">{t('notifications', 'title')}</span>
              <div className=" absolute top-3 right-3">
              <FaTimes className="cursor-pointer hover:scale-110 transition-all" onClick={toggleDropdown} />
            </div>
            </div>
            
            <div className="max-h-125 overflow-y-auto scrollbar-none">
              {isLoading ? (
                <Spinner />
              ) : notifications?.length > 0 ? (
                notifications?.map((notification: any) => (
                  <div
                    key={notification?.id}
                    className={`flex flex-col space-y-2 ${
                      notification?.isRead
                        ? "bg-white"
                        : "bg-color-notification"
                    }`}
                  >
                    <div className="flex p-4 space-x-4 items-center">
                      <FaBell className="w-9 h-9 flex-shrink-0" />
                      <div className="flex-grow">
                        <h5 className="text-primary text-lg break-words">
                          {notification?.title}
                        </h5>
                        <p className="text-gray-500 break-words">
                          {notification?.message}
                        </p>
                      </div>
                    </div>
                    <div className="border-b border-gray-300 w-full"></div>
                  </div>
                ))
              ) : (
                <div className=" h-full flex justify-center items-center min-h-[300px]">
                  <p className="p-4 text-[#FFC633] text-sm ">{t('notifications', 'text')}</p>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationsDropdown;
